import { render, staticRenderFns } from "./AssignCaseworkerToBooking.vue?vue&type=template&id=8a0b4172&scoped=true&"
import script from "./AssignCaseworkerToBooking.vue?vue&type=script&lang=js&"
export * from "./AssignCaseworkerToBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0b4172",
  null
  
)

export default component.exports